export default "__VITE_ASSET__DKILjXWe__"